var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.583 1.74L7.761.916 4.5 4.177 1.24.917l-.823.822L3.677 5 .418 8.26l.822.823L4.5 5.823l3.26 3.26.823-.822L5.323 5l3.26-3.26z",
    fill: "#94989E"
  })));
}
export default SvgCloseSmall;